export const INTUNE_ACCORDION_MAX_EXPANDED_BY_DEFAULT = 4

/** Template/baseline pickers: collapse when more than one template so the list stays scannable. */
export const INTUNE_TEMPLATES_ACCORDION_COLLAPSE_ABOVE_COUNT = 1

/**
 * Returns event keys to expand on first render, or null when all panels should start collapsed.
 */
export function getIntuneAccordionDefaultActiveKeys(eventKeys) {
  if (!Array.isArray(eventKeys) || eventKeys.length === 0) {
    return null
  }

  if (eventKeys.length > INTUNE_ACCORDION_MAX_EXPANDED_BY_DEFAULT) {
    return null
  }

  return eventKeys
}

export function shouldCollapseIntuneAccordionByDefault(itemCount) {
  return itemCount > INTUNE_ACCORDION_MAX_EXPANDED_BY_DEFAULT
}

export function shouldCollapseIntuneTemplatesAccordionByDefault(itemCount) {
  return itemCount > INTUNE_TEMPLATES_ACCORDION_COLLAPSE_ABOVE_COUNT
}

export function getIntuneTemplatesAccordionDefaultCollapsed(tabs, explicitDefaultCollapsed) {
  if (explicitDefaultCollapsed !== undefined) {
    return explicitDefaultCollapsed
  }

  const count = Array.isArray(tabs) ? tabs.length : 0
  return shouldCollapseIntuneTemplatesAccordionByDefault(count)
}
